import { Shuffle, Lightbulb, ShieldQuestion } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const challenges = [
  {
    icon: Shuffle,
    title: '"Scope and Hope" Contracting',
    description: "Corporate buyers define rigid technical parameters upfront and hope the new hardware produces results. When operating conditions change or integration snags appear—and they always do—the contract doesn't adapt. The risk stays with the buyer. The startup's tech stays sidelined.",
  },
  {
    icon: Lightbulb,
    title: 'Weak Incentives for Adaptation',
    description: 'When corporate procurement structures tie payments strictly to rigid delivery milestones or delivery timelines, startups are forced to execute outdated plans just to get paid. Neither side has the legal flexibility to optimize the hardware for real-world field performance.',
  },
  {
    icon: ShieldQuestion,
    title: 'Limited Accountability for Real Results',
    description: 'The pilot finishes. Engineering hours are billed. Initial setup metrics are met. Yet, the broader business problem remains unsolved. Traditional procurement leaves actual operational success ambiguous and vendor accountability completely unclear from day one.',
  },
];

const IndustryChallenges = () => {
  return (
    <section className="py-20 md:py-24 lg:py-28 relative">
      <div className="container px-4 sm:px-6 lg:px-8 mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="inline-flex items-center justify-center px-3 py-1 mb-4 rounded-full bg-accent/10 border border-accent/20">
            <span className="text-xs font-semibold tracking-[0.2em] text-accent uppercase">
              Problem
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-foreground">
            Why Traditional Procurement Stalls New Tech
          </h2>
          <p className="text-muted-foreground text-lg">
            Organisations don't fail at transformation because the robotics or hardware isn't good enough. They fail because traditional procurement frameworks are designed to reject startup speed and absorb massive capital risk.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {challenges.map((challenge, index) => {
            const Icon = challenge.icon;
            return (
              <Card
                key={index}
                className="glass-card hover:border-accent/20 transition-all duration-300 hover:shadow-lg hover:translate-y-[-4px]"
              >
                <CardContent className="p-6">
                  <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-accent/10">
                    <Icon className="h-6 w-6 text-accent" />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">
                    {challenge.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {challenge.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <p className="text-center max-w-3xl mx-auto mt-14 text-lg italic text-muted-foreground">
          There is a better model to fast-track technological induction. The question is not whether it works. The question is how quickly your organisation can adopt it.
        </p>
      </div>
    </section>
  );
};

export default IndustryChallenges;
